import React, { useContext } from 'react';
import { CompanyContext } from '../../../context/CompanyContext';
import { HashtagIcon } from '../../../VentoryUI/icons/Hashtag/HashtagIcon';
import { Card, CardContent, CardFooter } from '../../common/shadcn/card';
import { LoadingSpinner } from '../../pages/Common/LoadingSpinner';

interface ChartNumberProps {
  title: string;
  text: string;

  loading?: boolean;

  footerBuilder?: () => React.ReactNode;
}

export default function ChartNumber({ title, text, loading, footerBuilder = () => null }: ChartNumberProps) {
  const { currentCompany } = useContext(CompanyContext);

  const footer = footerBuilder();

  return (
    <div className='w-full rounded-4 border border-gray-100'>
      <div className='flex h-12 items-center border-b px-2'>
        <HashtagIcon className='px-3' color={currentCompany.settings.primaryColor} />
        <p className='line-clamp-1 overflow-ellipsis font-medium text-subtitle'>{title}</p>
      </div>
      <div className='h-[72px]'>
        {!loading ? (
          <Card className='rounded-none border-none px-0 py-4 shadow-none'>
            <CardContent className='px-0'>
              <div className='flex h-full justify-center'>
                <p className='text-3xl text-subtitle'>{parseFloat(text).toLocaleString()}</p>
              </div>
            </CardContent>
            {footer ? <CardFooter className='flex-col items-start gap-2 text-sm'>{footer}</CardFooter> : null}
          </Card>
        ) : (
          <div className='flex h-full items-center justify-center'>
            <LoadingSpinner color={currentCompany.settings.primaryColor} />
          </div>
        )}
      </div>
    </div>
  );
}
